(function () {
  const LOADER_KEY = "loaderPlayed";
  const FORCE_LOADER_KEY = "forceLoader";

  const shouldPlayLoader =
    !sessionStorage.getItem(LOADER_KEY) ||
    sessionStorage.getItem(FORCE_LOADER_KEY) === "true";

  if (!shouldPlayLoader) {
    const loader = document.getElementById("loader_Main");
    if (loader) loader.style.display = "none";
    return;
  }

  sessionStorage.setItem(LOADER_KEY, "true");
  sessionStorage.removeItem(FORCE_LOADER_KEY);

  document.body.classList.add("loading");
  document.body.style.opacity = "1";

  setTimeout(() => {
    if (typeof window.initFramesAnimation === "function") {
      window.initFramesAnimation();
    }
  }, 100);

  setTimeout(() => {
    document.body.classList.remove("loading");

    gsap.to(".header-wrapper", {
      y: 0,
      opacity: 1,
      visibility: "visible",
      duration: 0.1,
      ease: "power3.out"
    });
  }, 100);

  const init = () => {
    gsap.set(".loader_text", { autoAlpha: 0 });
    gsap.set(".loader_num.intro_text, .loader_year.intro_text", { autoAlpha: 0 });

    document.querySelectorAll(".loader_text").forEach(text => {
      const chars = text.textContent.split("");
      text.textContent = "";
      chars.forEach(char => {
        const span = document.createElement("span");
        span.textContent = char === " " ? "\u00A0" : char;
        text.appendChild(span);
      });
    });

    const tl = gsap.timeline();
    const blocks = document.querySelectorAll("#loader_Main .loader_info");

    blocks.forEach((block, index) => {
      const text = block.querySelector(".loader_text");
      const letters = text.querySelectorAll("span");
      const num = block.querySelector(".loader_num.intro_text");
      const year = block.querySelector(".loader_year.intro_text");
      const startTime = index === 0 ? 0.1 : "-=0.08";

      tl.to(text, { autoAlpha: 1, duration: 0.02, delay: 0.02 }, startTime);
      tl.from(letters, {
        y: 10,
        opacity: 0,
        stagger: 0.01,
        duration: 0.08,
        ease: "power3.out"
      });

      tl.to([num, year], { autoAlpha: 1, duration: 0.05 }, "<0.01");
      tl.to({}, { duration: 0.02 });
      tl.to([num, year], { autoAlpha: 0, duration: 0.05 });

      tl.to(letters, {
        y: -10,
        opacity: 0,
        stagger: 0.01,
        duration: 0.08,
        ease: "power3.in"
      }, "<0.01");

      tl.to(text, { autoAlpha: 0, duration: 0.02 });
    });
  };

  gsap.to("#loader_Main", {
    opacity: 0,
    pointerEvents: "none",
    ease: "power4.inOut",
    duration: 0.1,
    delay: 0.1
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

document.addEventListener("DOMContentLoaded", () => {
  if (typeof window.initFramesAnimation === "function") {
    window.initFramesAnimation();
  }
});